import React from 'react';
import { Text, ButtonStandard } from '@stashinvest/react-components';
import { BanjoString } from '@stashinvest/react-banjo';

const handleReload = () => {
	if (new URLSearchParams(window.location.search).has('error')) {
		window.location.replace(window.location.origin);
	} else {
		window.location.reload();
	}
};

type ErrorMessageComponentProps = {
	onRetry?: () => void;
};

const ErrorMessageComponent = ({ onRetry }: ErrorMessageComponentProps) => (
	<div className="flex min-h-[95vh] flex-col items-center justify-center">
		<div className="w-full max-w-[28rem] text-center">
			<Text
				tag="h1"
				textStyle="headerSmall"
				color="text-onSurface"
				className="mb-contentSmall"
			>
				Whoops, something went wrong
			</Text>
			<Text
				tag="p"
				textStyle="bodyMediumStandard"
				color="text-onSurface"
				className="mb-contentSmall"
			>
				{onRetry ? (
					<BanjoString stringId="information/instruct/retrySoon" />
				) : (
					<>
						Try reloading or clearing your browser&#8217;s history or cache and logging
						back in.
					</>
				)}
			</Text>
		</div>
		<div className="w-full max-w-[28rem] text-center">
			<ButtonStandard
				type="button"
				variant="primary"
				onClick={onRetry ?? handleReload}
				className="mb-contentMedium min-w-full"
			>
				{onRetry ? <BanjoString stringId="action/startTask/retry" /> : 'Reload Stash'}
			</ButtonStandard>
		</div>
	</div>
);

export default ErrorMessageComponent;
